import moment from 'moment';
import Base from './Base';

export default class VacationRequest extends Base {
    constructor(props) {
        super();
        this.import(props);
    }

    import(props) {
        if (!props) {
            props = {};
        }

        if (typeof props === 'number') {
            this.id = props;
            return;
        }

        this.id = this.assign('id', props);
        this.employeeId = this.assign('employeeId', props);
        this.startDate = this.assign('startDate', props);
        this.endDate = this.assign('endDate', props);
        this.type = this.assign('type', props) || 'vacation';
        this.status = this.assign('status', props) || 'pending';
        this.reason = this.assign('reason', props);
        this.adminNotes = this.assign('adminNotes', props);
        this.processedById = this.assign('processedById', props);
        this.processedAt = props.processedAt ? moment(props.processedAt) : null;
        this.workingDays = this.assign('workingDays', props);
        
        // Nested objects
        this.employee = this.assign('employee', props);
        this.processedBy = this.assign('processedBy', props);
        
        this.createdAt = props.createdAt ? moment(props.createdAt) : null;
        this.updatedAt = props.updatedAt ? moment(props.updatedAt) : null;
    }

    export() {
        return {
            id: this.id,
            employeeId: this.employeeId,
            startDate: this.startDate,
            endDate: this.endDate,
            type: this.type,
            reason: this.reason
        };
    }

    get displayStatus() {
        const statusMap = {
            pending: 'În așteptare',
            approved: 'Aprobat',
            rejected: 'Respins',
            cancelled: 'Anulat'
        };
        return statusMap[this.status] || this.status;
    }

    get displayType() {
        const typeMap = {
            vacation: 'Concediu',
            sick: 'Medical',
            personal: 'Personal',
            unpaid: 'Neplătit',
            maternity: 'Maternitate',
            paternity: 'Paternitate',
            bereavement: 'Deces',
            other: 'Altele'
        };
        return typeMap[this.type] || this.type;
    }

    get statusColor() {
        const colorMap = {
            pending: 'yellow',
            approved: 'green',
            rejected: 'red',
            cancelled: 'neutral'
        };
        return colorMap[this.status] || 'neutral';
    }
}
